// extracted by mini-css-extract-plugin
module.exports = {"root":"Growth_root__3yjop","nav":"Growth_nav__3Nvd5","divider":"Growth_divider__3AQDY"};